<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
          <g-wiki keyValue="WIKI_FIJAS"/>
          NOVEDADES FIJAS
        </span>
        <g-master name="frq"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :beforeSend="master.beforeSend"
                  modalWidth="80%"
                  @action="masterAction"
                  ref="master"
                  :actions="master.actions"
                  @params="paramsTable"
                  :parentData="filterParams"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="customButton" v-if="mostrarFiltro === 'SI'">
            <a-select placeholder="Filtro Por Estado" style="width: 200px" v-model="filterStatus" v-bind="selOptions" >
              <a-select-option v-for="opcion in estados" :key="opcion.value"  >
                {{ opcion.name }}
              </a-select-option>
            </a-select>
            <a-button type="primary" @click="filtrar">Filtrar</a-button>
          </template>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='CERRADA' ? 'red' : (text === 'ACTIVA' ? 'blue' : 'blue')">{{text}}</a-tag>
          </span>
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Empleado')"
                          :formItemConfig="fiOptions"
                          :selectedObj.sync="empleadoseleccionado"
                          endpoint="empleados_en_reqliquidacion"
                          ref="empleado"
                          :decorator="['id_emp', { rules: [{ required: true, message: 'Valor requerido' }] }]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Concepto')"
                          :formItemConfig="fiOptions"
                          endpoint="coc"
                          ref="concepto"
                          :decorator="['id_coc', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="{filtro_grupo: true}">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Moneda')"
                            :formItemConfig="fiOptions"
                            :decorator="['currency', { rules: [{ required: true, message: 'Valor requerido'}], initialValue: 'COP' }]"
                            :params="code_currency">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Valor novedad fija')">
                  <a-input-number
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    style="width: 100%"
                    :disabled="isDisabledNovedades"
                    v-decorator="['frq_value', { rules: [{ required: false, message:'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Período')"
                            :formItemConfig="fiOptions"
                            :decorator="['frq_period', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="periodos_liquidacion">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown v-bind="fiOptions"
                            :disabled="inactiveStatus"
                            endpoint="hierarchy_lookup"
                            :label="$t('Estado')"
                            :formItemConfig="fiOptions"
                            :decorator="['frq_status', { rules: [{ required: true, message: 'Valor requerido' }], initialValue: 'ACT' }]"
                            :params="status">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha inicial')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 :disabled="isDisabledNovedades"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['frq_since', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha final')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['frq_to', { rules: [{ required: false, message: 'Valor requerido'}, { validator: validateDate }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Saldo inicial Nov.')">
                  <a-input-number
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    style="width: 100%"
                    v-decorator="['frq_saldoini', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Saldo Nov. fija')">
                  <a-input-number
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    style="width: 100%"
                    v-decorator="['frq_saldo', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Valor acumulado')">
                  <a-input-number
                    :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                    :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                    style="width: 100%"
                    v-decorator="['frq_acum', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Cons. de cargue')">
                  <a-input
                    style="width: 100%"
                    class="ant-uppercase"
                    v-decorator="['description', { rules: [{ required: false }]}]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Comentarios')">
                  <a-textarea
                    autoSize
                    style="width: 100%"
                    v-decorator="['frq_comments', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
            <a-card v-if="verCar">
              <a-alert
                message="Advertencia"
                :description="error"
                type="warning"
                show-icon
              />
            </a-card>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
    <template>
      <a-modal v-model="visible" title="Tiempo límite" :footer="null">
        <a-result status="warning"
                  title="La fecha de Novedad ha caducado para el Calendario de Nomina Activo, por favor consulte su administrador HRO">
          <template #extra>
            <a-button @click="handleOk" type="primary">
              Cerrar
            </a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        verCar: false,
        error: '',
        fecha_inicio: null,
        id_emp: null,
        empleadoseleccionado: {},
        selOptions: {
          allowClear: true
        },
        filterStatus: 'ACT',
        filterParams: {
          status_desc: 'ACT'
        },
        estados: [
          {name: 'ACTIVAS', value: 'ACT'},
          {name: 'CERRADAS', value: 'CER'},
          {name: 'TODOS', value: null}
        ],
        mostrarFiltro: this.$getConfigValue('NOVEDADES_FIJAS_FILTRO_ESTADO', null),
        fileNameExcel: 'novedades_fijas',
        paramsT: {},
        endpointExcel: 'frq_novedades_fijas/downloadExcel',
        inactiveStatus: false,
        visible: false,
        isDisabledNovedades: true,
        fecha_inicial: null,
        fecha_final: null,
        status: {
          h_lookup_type: 'ESTADO_NOVEDAD',
          use_code: true
        },
        nombreEntidad: {},
        nombreEntidadSeleccionada: '',
        code_status_sn: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        tipo_entidad: {
          h_lookup_type: 'TIPO_ENTIDAD',
          use_code: true
        },
        code_currency: {
          h_lookup_type: 'MONEDA',
          use_code: true
        },
        periodos_liquidacion: {
          h_lookup_type: 'PERIODOS_LIQUIDACION',
          use_code: true
        },
        tipoEntidadSeleccionada: {},
        colOptions: {xs: 24, sm: 8},
        colSpan: {xs: 24, sm: 6},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        master: {
          beforeSend: (data) => {
            return {...data, prc: 1}
          },
          valoresExpandidos: [
            {label: 'Consecutivo de cargue', column: 'description'},
            {label: 'Comentarios', column: 'frq_comments'},
            {label: 'Fecha de inicio', column: 'fecha_inicio'},
            {label: 'Fecha de fin', column: 'fecha_fin'}
          ],
          endpoint: 'frq',
          isVisibleCreate: true,
          actions: [],
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    if (record.frq_status === 'ACT' || (record.frq_status === 'CER' && (this.$userIsInrol('RightHand') || this.$userIsInrol('Management')))) {
                      return true
                    }
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    if (record.frq_status === 'CER') {
                      return false
                    } else if (record.frq_status === 'ACT') {
                      return true
                    }
                  }
                }
              ]
            },
            customSlots: ['expandedRowRender', 'estadoRenderer'],
            tableConfig: {
              rowKey: 'frq_id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: '#', dataIndex: 'frq_id', sorter: true},
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'nombre_empleado', sorter: true},
              {title: 'ID del concepto', dataIndex: 'id_coc', sorter: true},
              {title: 'Concepto', dataIndex: 'nombre_concepto', sorter: true},
              {title: 'Moneda', dataIndex: 'currency', sorter: true},
              {title: 'Valor novedad fija', dataIndex: 'frq_value', sorter: true, align: 'right'},
              {title: 'Período', dataIndex: 'period_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'status_desc',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Saldo Nov. fija', dataIndex: 'frq_saldo', sorter: true, align: 'right'},
              {title: 'Saldo inicial', dataIndex: 'frq_saldoini', sorter: true, align: 'right'},
              {title: 'Valor acumulado', dataIndex: 'frq_acum', sorter: true, align: 'right'},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Actualizado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Actualizado el', dataIndex: 'modified_on', sorter: true}
            ],
            allowSelect: true,
            selectedRows: [],
            selectedRowKeys: []
          },
          modalFieldsSetup: [
            {name: 'id_emp'},
            {name: 'id_coc'},
            {name: 'currency'},
            {name: 'frq_value'},
            {name: 'frq_period'},
            {name: 'frq_status'},
            {name: 'frq_since'},
            {name: 'frq_to'},
            {name: 'frq_saldo'},
            {name: 'frq_saldoini'},
            {name: 'frq_acum'},
            {name: 'frq_comments'},
            {name: 'description'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
      this.limiteRegistroNovedad()
    },
    methods: {
      objectoEmpleadoSeleccionado () {
        let emp = ''
        if (!JsUtils.isEmpty(this.empleadoseleccionado)) {
          if (!JsUtils.isEmpty(this.empleadoseleccionado.value)) {
            emp = this.empleadoseleccionado.value
            this.id_emp = emp
          }
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.verCar = false
            this.id_emp = null
            this.isDisabledNovedades = false
            let fechaActual = new Date()
            fechaActual = fechaActual.getFullYear() + '-' + (fechaActual.getMonth() + 1) + '-' + '1'
            this.fecha_inicial = fechaActual
            this.$refs.master.modal.form.setFieldsValue({
              frq_since: fechaActual,
              id_emp: undefined
            })
            break
          case 'fieldsChange':
            if (this.$getConfigValue('MOSTRAR_ALERTA_VALI_FECHA_INI_NOV_VS_FECHA_INI_EMP', 'NO') === 'SI') {
              if (!JsUtils.isEmpty(action.changedFields) &&
                !JsUtils.isEmpty(action.changedFields.frq_since)) {
                this.fecha_inicio = action.changedFields.frq_since.value
                if (!JsUtils.isEmpty(this.id_emp) && !JsUtils.isEmpty(this.fecha_inicio)) {
                  this.validarFechaIniNov(this.id_emp, this.fecha_inicio)
                }
              }
            }
            let fIni = action.changedFields.frq_since.hasOwnProperty('value') ? action.changedFields.frq_since.value : null
            if (!JsUtils.isEmpty(fIni)) {
              this.fecha_inicial = new Date(action.changedFields.frq_since.value)
            }
            let fFin = action.changedFields.frq_to.hasOwnProperty('value') ? action.changedFields.frq_to.value : null
            if (!JsUtils.isEmpty(fFin)) {
              this.fecha_final = new Date(action.changedFields.frq_to.value)
            }
            break

          case 'masterEdit':
            this.verCar = false
            this.id_emp = action.record.id_emp
            this.empleadoseleccionado = {value: action.record.id_emp}
            this.objectoEmpleadoSeleccionado()
            if (action.record.frq_since) {
              this.fecha_inicial = new Date(action.record.frq_since)
            } else {
              this.fecha_inicial = null
            }
            if (action.record.frq_to) {
              this.fecha_final = new Date(action.record.frq_to)
            } else {
              this.fecha_final = null
            }
            this.novedadProcesada(action.record.frq_id)
            this.inactiveStatus = action.record.status_desc === 'CERRADA'
            this.$nextTick(() => {
              if (!JsUtils.isEmpty(action.record.id_emp)) {
                this.$refs.empleado && this.$refs.empleado.handleSearch(action.record.id_emp)
              }
              if (!JsUtils.isEmpty(action.record.id_coc)) {
                this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.id_coc)
              }
            })
            break
          case 'rowClone':
            if (JsUtils.isEmpty(this.cloneTorecord)) {
              Mensajes.error('Error', 'Selecciona una fila para colonar')
              return
            }
            this.$confirm({
              title: 'Clonar',
              content: '¿Está seguro que desea clonar el registro?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().post(this.master.endpoint, {
                    ...this.cloneTorecord
                  })
                    .then((response) => {
                      let key = this.master.tableSetup.tableConfig.rowKey
                      let clone = {...this.cloneTorecord}
                      clone[key] = response.data[key]
                      this.$refs.master.$refs.datatable.loadData()
                      this.$refs.master.$refs.datatable.handleRadioSelection(response.data)
                      this.master.tableSetup.selectedRowKeys = [response.data[key]]
                      this.master.tableSetup.selectedRows = [response.data]
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible clonar el registro'))
                      reject(error)
                    })
                })
              },
              onCancel () { }
            })
            break
        }
      },
      validateDate (rule, value, callbackFn) {
        if (this.fecha_final && this.fecha_inicial > this.fecha_final) {
          callbackFn('La fecha inicial no puede ser mayor a la final')
          return false
        } else {
          return true
        }
      },
      handleOk () {
        this.visible = false
      },
      limiteRegistroNovedad () {
        if (this.$userIsInrol('RightHand') || this.$userIsInrol('Management') || this.$userIsInrol('AdminNomina')) {
          this.master.actions.push(
            {
              name: 'rowClone',
              text: 'Clonar',
              permisos: [],
              props: {icon: 'plus', type: 'button'}
            },
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'}
            })
        } else {
          this.httpClient.getInstance().get('tiempo_limite')
            .then(response => {
              if (response.data[0].tiempolimite != '1') {
                this.visible = true
                this.master.actions.splice(0)
              } else {
                this.master.actions.push({
                  name: 'masterCreate',
                  text: 'Crear',
                  permisos: [],
                  props: {icon: 'plus', type: 'button'}
                })
              }
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posble cargar el tiempo límite para registrar una novedad')
            })
        }
      },
      novedadProcesada (frq_id) {
        if (this.$userIsInrol('RightHand') || this.$userIsInrol('Management') || this.$userIsInrol('AdminNomina') || this.$userIsInrol('TecniNomina')) {
          this.isDisabledNovedades = false
        } else {
          this.$message.error('La novedad se encuentra procesada. ' +
            'No se puede modificar los campos: Valor Novedad Fija y Fecha Inicial.')
          this.httpClient.getInstance().get('novedad_procesada/' + frq_id)
            .then(response => {
              this.isDisabledNovedades = response.data !== '1'
            })
            .catch(() => {
              Mensajes.error('Error', 'No fue posble cargar el tiempo límite para registrar una novedad.')
            })
        }
      },
      paramsTable (params) {
        this.paramsT = params
      },
      filtrar () {
        this.filterParams = {status_desc: this.filterStatus}
      },
      validarFechaIniNov (idEmp, fechaIni) {
        this.httpClient.getInstance().post('validar_fecha_ini_nov', {
          id_emp: idEmp,
          fecha_inicio: fechaIni
        })
          .then((response) => {
            if (parseInt(response.data) !== 0) {
              this.verCar = true
              this.error = response.data
            } else {
              this.verCar = false
            }
          })
          .catch((error) => {
            this.verCar = true
            this.error = this.$getErrorMessage(error, 'No fue posible validar la fecha inicial, contacte al administrador.')
          })
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT}
      },
      cloneTorecord () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      }
    },
    watch: {
      empleadoseleccionado () {
        this.objectoEmpleadoSeleccionado()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Frq.vue